import config from '../../../config';

export default {
    mode: undefined,
    dateType: 'booking',
    season: {
        from: config.business.SEASON_DATE_START,
        to: config.business.SEASON_DATE_END
    },
    bookingPeriod: {
        from: config.business.SEASON_DATE_START,
        to: config.business.SEASON_DATE_END
    },
    arrivalPeriod: {
        from: config.business.SEASON_DATE_START,
        to: config.business.SEASON_DATE_END
    },
    totalRevenue: {
        value: undefined,
        loading: false,
        error: false,
        noContent: false
    },
    totalBookings: {
        value: undefined,
        loading: false,
        error: false,
        noContent: false
    },
    periodRevenue: {
        value: undefined,
        loading: false,
        error: false,
        noContent: false
    },
    periodBookings: {
        value: undefined,
        loading: false,
        error: false,
        noContent: false
    },
    statSites: {
        loading: false,
        error: false,
        noContent: false,
        predicate: "revenue",
        predicates: ["revenue", "bookings"]
    },
    statList: {
        selectedItem: undefined,
        predicate: "revenue",
        predicates: ["revenue", "bookings"]
    },
    statInventory: {
        predicate: "revenue",
        predicates: ["revenue", "bookings"]
    },
    sites: undefined,
    selectedSite: undefined,
    inventory: undefined,
    tips: [
        {
            title: 'tips.statPage.boxes.title',
            body: 'tips.statPage.boxes.body'
        },
        {
            title: 'tips.statPage.graph.title',
            body: 'tips.statPage.graph.body'
        },
        {
            title: 'tips.statPage.filter.title',
            body: 'tips.statPage.filter.body'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/store/modules/stats/state.js